export const LOGIN_ACTIONS = {
    SUCCESS: 'success',
    LOGOUT: 'logout',
    NO_SESSION: 'no_session',
    ORG_LIST: 'org_list',
    NEW_PASSWORD_REQUIRED: 'new_password',
    NEW_PASSWORD_SET: 'NEW_PASSWORD_SET'
}